import config from "@/config";
import { requests } from ".";

const FORM_SERVER_URL = config?.FORM_SERVER_URL;

export interface FormsCustomFieldDTO {
  customFieldId: string;
  formDataType: string;
  customFieldType: string;
  formId?: string | null;
  productType: "form" | "survey" | "quiz";
}

export interface FormsCustomFieldSaveItem {
  customFieldId: string;
  formDataType: string;
  customFieldType: string;
  formId?: string;
  productType: "form" | "survey" | "quiz";
}

interface FormsCustomFieldsListResponse {
  items: FormsCustomFieldDTO[];
  nextCursor?: string;
}

export const FormsCustomFieldsService = {
  list: async (
    locationId: string,
    customFieldIds?: string[],
    cursor?: string
  ): Promise<FormsCustomFieldsListResponse> => {
    const params = new URLSearchParams({ locationId });
    if (customFieldIds?.length) {
      params.set("customFieldIds", customFieldIds.join(","));
    }
    if (cursor) {
      params.set("cursor", cursor);
    }
    const url = `/forms-custom-fields/metadata?${params.toString()}`;
    const response = await requests(FORM_SERVER_URL + "/forms").get(url);
    return response.data;
  },

  save: async (
    locationId: string,
    items: FormsCustomFieldSaveItem[],
    productType?: "form" | "survey" | "quiz"
  ): Promise<void> => {
    await requests(FORM_SERVER_URL + "/forms").post(
      "/forms-custom-fields/metadata",
      { locationId, productType, items }
    );
  },
};
